
import { IComponentAs } from '@uifabric/utilities/lib/IComponentAs';
import { IItemDefaultDropZoneProps } from '../components/defaultDropZone/DefaultDropZone';
import { ControlFacet } from '../models/controls/ControlFacet';
import { defaultRenderComponentOption } from '../components/controls/defaultRenderComponentControlOption';

export interface IItemDragDropControlProps {
  /**
   * The item to use as the drag source or target.
   */
  itemKey: string | undefined;
}

export interface IItemDragDropControlOverrides {
  /**
   * The component to use for the drag/drop zone.
   * Note that since the children passed to the component may be a render prop,
   * the implementing component should use `renderChildrenWithProps` and pass a final `IActionDropZoneStateProps` object.
   */
  itemDropZone: IComponentAs<IItemDefaultDropZoneProps>;
}

/**
 * Control hook to replace or extend the drag/drop zones within Items View components.
 */
export const itemDragDropControl: ControlFacet<IItemDragDropControlProps, IItemDragDropControlOverrides> =
  new ControlFacet<IItemDragDropControlProps, IItemDragDropControlOverrides>('itemDragDrop', {
    itemDropZone: defaultRenderComponentOption<IItemDefaultDropZoneProps>({
      useItemCache: true
    })
  });
